// Copyright (c) Docugami, Inc. All rights reserved.

interface FormattedTextComponentsProps {
    formatString: string,
    formatArgs: string[],
    createNormalTextCb: (text: string, key: number) => JSX.Element,
    createFormattedTextCb: (text: string, key: number) => JSX.Element
}

/**
 * Helper for taking a format string such as "This is a {0} example." and creating a collection of spans
 * that represent the same string with format tokens replaced with values in the given format args array.
 * Format args are currently just strings and will be displayed in bold.
 */
export const getFormattedTextComponents = (props: FormattedTextComponentsProps): JSX.Element[] => {
    let result: JSX.Element[] = [];
    let remaining = props.formatString;
    for (let i = 0; i < props.formatArgs.length; ++i) {
        const formatToken = `{${i}}`;
        const tokenIndex = remaining.indexOf(formatToken);

        let normalText = '';
        let boldText = '';
        if (tokenIndex === -1) {
            normalText = remaining;
            remaining = ''
        }
        else {
            normalText = remaining.substring(0, tokenIndex);
            boldText = props.formatArgs[i];
            remaining = remaining.substring(tokenIndex + formatToken.length);
        }

        if (!!normalText) {
            result.push(props.createNormalTextCb(normalText, result.length))
        }

        if (!!boldText) {
            result.push(props.createFormattedTextCb(boldText, result.length))
        }
    }

    result.push(props.createNormalTextCb(remaining, result.length));

    return result;
}

export function ordinal_suffix_of(num: number): string {
    const j = num % 10, k = num % 100;

    if (j === 1 && k !== 11) {
        return "st";
    } else if (j === 2 && k !== 12) {
        return "nd";
    } else if (j === 3 && k !== 13) {
        return "rd";
    } else {
        return "th";
    }
}

export function formatStringIfNumeric(str: string) {
    let formattedStr = str;
    const num = parseInt(formattedStr);
    if (!isNaN(num)) {
        formattedStr = num.toLocaleString();
    }

    return formattedStr;
}

export function toPascalCase(text: string, separator: string = ' '): string {
    if (!text || !text.trim()) {
        return text;
    }

    return text.split(' ')
        .map(word => {
            const trimmedWord = word.trim();
            if (!trimmedWord) {
                return trimmedWord;
            }
            return `${trimmedWord[0].toUpperCase()}${trimmedWord.substring(1).toLowerCase()}`
        })
        .join(separator);
}
